<template>
  <!-- corpo da aba do podio; o card e o cabecalho ficam no IncentivosHome -->
  <div class="podio">
      <div class="row">
        <!-- esquerda: regra, minha posicao, top 3 e premios -->
        <div class="col-lg-5 mb-3 mb-lg-0">
          <p class="podio-regra">
            As <b>{{ dados.top }}</b> revendedoras com mais unidades ganham<template v-if="dados.minimo_mes">,
            com no mínimo <b>{{ dados.minimo_mes }}</b> unidades em cada mês</template>.
          </p>

          <div v-if="meu" class="podio-meu" :class="'podio-meu--' + estadoMeu">
            <div class="podio-meu-pos">
              <span class="podio-meu-num">{{ meu.posicao ? meu.posicao + 'º' : '—' }}</span>
              <span class="podio-meu-rotulo">{{ meu.posicao ? 'sua posição' : 'fora do ranking' }}</span>
            </div>
            <div class="podio-meu-info">
              <div>
                <strong>{{ meu.total_unidades }}</strong> unidade(s) no total
              </div>
              <div v-if="estadoMeu === 'premiada' && meu.premio">
                Prêmio atual: <strong>{{ meu.premio }}</strong>
              </div>
              <div v-else-if="meu.falta_top !== null && meu.falta_top !== undefined">
                Faltam <strong>{{ meu.falta_top }}</strong> unidade(s) para o {{ dados.top }}º lugar
              </div>
              <div class="podio-meses">
                <span
                  v-for="(mes, i) in dados.meses"
                  :key="mes"
                  class="podio-mes"
                  :class="{ 'podio-mes--ok': bateuMes(meu.unidades_mes[i]) }"
                >
                  <i v-if="bateuMes(meu.unidades_mes[i])" class="fas fa-check mr-1"></i>
                  {{ mes }} <b>{{ meu.unidades_mes[i] || 0 }}</b><template v-if="dados.minimo_mes">/{{ dados.minimo_mes }}</template>
                </span>
              </div>
              <small class="podio-meu-situacao">{{ meu.situacao }}</small>
            </div>
          </div>

          <div v-if="podio.length" class="podio-degraus">
            <div
              v-for="item in podio"
              :key="item.id"
              class="podio-degrau"
              :class="['podio-degrau--' + item.posicao, { 'podio-degrau--eu': ehEu(item) }]"
            >
              <div class="podio-medalha">{{ item.posicao }}º</div>
              <div class="podio-nome" :title="item.nome">{{ item.nome }}</div>
              <div class="podio-cidade">{{ item.cidade }}/{{ item.uf }}</div>
              <div class="podio-bloco">
                <span class="podio-bloco-num">{{ item.total_unidades }}</span>
                <span class="podio-bloco-un">unidades</span>
              </div>
            </div>
          </div>

          <div v-if="dados.faixas.length" class="podio-faixas">
            <div class="podio-faixas-titulo">Prêmios</div>
            <div v-for="(f, i) in dados.faixas" :key="i" class="podio-faixa" :class="'podio-faixa--' + i">
              <span class="podio-faixa-pos">{{ f.de }}º a {{ f.ate }}º</span>
              <span>{{ f.premio }}</span>
            </div>
          </div>
        </div>

        <!-- direita: listas -->
        <div class="col-lg-7">
      <b-tabs content-class="mt-3" small>
        <b-tab :title="'Top ' + dados.top" active>
          <div class="podio-busca">
            <b-form-input v-model="busca" size="sm" placeholder="Buscar revendedora ou cidade" />
            <b-button v-if="meu && meu.posicao && meu.posicao <= dados.top" size="sm" variant="outline-primary" @click="irParaMim">
              <i class="fas fa-crosshairs mr-1"></i>Minha posição
            </b-button>
          </div>
          <div ref="lista" class="podio-lista">
            <table class="table table-sm mb-0">
              <thead>
                <tr>
                  <th class="text-center">#</th>
                  <th>Revendedora</th>
                  <th class="d-none d-md-table-cell">Cidade</th>
                  <th class="text-right">Unid.</th>
                  <th class="d-none d-sm-table-cell">Prêmio</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="item in rankingFiltrado"
                  :key="item.id"
                  :ref="'linha' + item.id"
                  :class="['podio-linha--' + faixaDe(item.posicao), { 'podio-linha--eu': ehEu(item) }]"
                >
                  <td class="text-center podio-pos">{{ item.posicao }}º</td>
                  <td>{{ item.nome }}</td>
                  <td class="d-none d-md-table-cell">{{ item.cidade }}/{{ item.uf }}</td>
                  <td class="text-right"><b>{{ item.total_unidades }}</b></td>
                  <td class="d-none d-sm-table-cell podio-premio">{{ item.premio }}</td>
                </tr>
                <tr v-if="!rankingFiltrado.length">
                  <td colspan="5" class="text-center text-muted py-3">Nenhuma revendedora encontrada.</td>
                </tr>
              </tbody>
            </table>
          </div>
        </b-tab>

        <b-tab v-if="dados.rede.length" :title="'Sua rede (' + dados.rede.length + ')'">
          <p class="podio-rede-resumo">
            <b>{{ dados.rede.length }}</b> revendedora(s) da sua rede participando,
            <b>{{ redeNoTop }}</b> entre as {{ dados.top }} primeiras.
          </p>
          <div class="podio-lista">
            <table class="table table-sm mb-0">
              <thead>
                <tr>
                  <th class="text-center">#</th>
                  <th>Revendedora</th>
                  <th v-for="mes in dados.meses" :key="mes" class="text-center d-none d-lg-table-cell">{{ mes }}</th>
                  <th class="text-right">Total</th>
                  <th>Prêmio / situação</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in dados.rede" :key="item.id" :class="'podio-linha--' + faixaDe(item.posicao)">
                  <td class="text-center podio-pos">{{ item.posicao ? item.posicao + 'º' : '—' }}</td>
                  <td>{{ item.nome }}</td>
                  <td
                    v-for="(mes, i) in dados.meses"
                    :key="mes"
                    class="text-center d-none d-lg-table-cell"
                    :class="{ 'text-success font-weight-bold': bateuMes(item.unidades_mes[i]) }"
                  >{{ item.unidades_mes[i] || 0 }}</td>
                  <td class="text-right"><b>{{ item.total_unidades }}</b></td>
                  <td class="podio-premio">
                    <template v-if="item.posicao && item.posicao <= dados.top">{{ item.premio }}</template>
                    <small v-else class="text-muted">{{ item.situacao }}</small>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </b-tab>
      </b-tabs>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  props: {
    dados: { type: Object, required: true },
  },
  data() {
    return {
      busca: "",
    };
  },
  computed: {
    meu() {
      return this.dados.meu;
    },
    estadoMeu() {
      if (!this.meu || !this.meu.posicao) return "fora";
      return this.meu.posicao <= this.dados.top ? "premiada" : "disputa";
    },
    podio() {
      const [p1, p2, p3] = this.dados.ranking;
      // ordem visual: 2o, 1o, 3o
      return [p2, p1, p3].filter(Boolean);
    },
    rankingFiltrado() {
      const termo = this.normaliza(this.busca);
      if (!termo) return this.dados.ranking;
      return this.dados.ranking.filter((item) =>
        this.normaliza(item.nome + " " + item.cidade + " " + item.uf).includes(termo)
      );
    },
    redeNoTop() {
      return this.dados.rede.filter((i) => i.posicao && i.posicao <= this.dados.top).length;
    },
  },
  methods: {
    normaliza(texto) {
      return (texto || "")
        .normalize("NFD")
        .replace(/[̀-ͯ]/g, "")
        .toLowerCase()
        .trim();
    },
    bateuMes(qtd) {
      return !!this.dados.minimo_mes && (qtd || 0) >= this.dados.minimo_mes;
    },
    ehEu(item) {
      return !!this.meu && this.meu.id === item.id;
    },
    faixaDe(posicao) {
      if (!posicao) return "fora";
      const i = this.dados.faixas.findIndex((f) => posicao >= f.de && posicao <= f.ate);
      return i >= 0 ? i : "fora";
    },
    irParaMim() {
      this.busca = "";
      this.$nextTick(() => {
        const linha = this.$refs["linha" + this.meu.id];
        const el = Array.isArray(linha) ? linha[0] : linha;
        const lista = this.$refs.lista;
        if (el && lista) {
          lista.scrollTop = el.offsetTop - lista.clientHeight / 2;
        }
      });
    },
  },
};
</script>

<style scoped>
.podio-regra {
  margin-bottom: 14px;
  color: #495057;
}

/* minha posicao */
.podio-meu {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 14px 18px;
  margin-bottom: 20px;
  border-radius: 6px;
  border-left: 5px solid #6c757d;
  background: #f4f5f7;
}
.podio-meu--premiada {
  border-left-color: #28a745;
  background: #eef8f0;
}
.podio-meu--disputa {
  border-left-color: #4f6f96;
  background: #eef3f9;
}
.podio-meu-pos {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 90px;
}
.podio-meu-num {
  font-size: 2.4rem;
  font-weight: 700;
  line-height: 1;
}
.podio-meu-rotulo {
  font-size: 0.75rem;
  text-transform: uppercase;
  color: #6c757d;
}
.podio-meu-linha {
  font-size: 1rem;
}
.podio-meses {
  margin: 8px 0 4px;
}
.podio-mes {
  display: inline-block;
  margin: 0 6px 4px 0;
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 0.8rem;
  background: #fff;
  border: 1px solid #d6dbe1;
}
.podio-mes--ok {
  color: #1e7e34;
  border-color: #9fd5ab;
  background: #f1faf3;
}
.podio-meu-situacao {
  color: #6c757d;
}

/* top 3 */
.podio-degraus {
  display: flex;
  justify-content: center;
  align-items: flex-end;
  gap: 12px;
  margin-bottom: 20px;
}
.podio-degrau {
  flex: 0 1 220px;
  min-width: 0;
  text-align: center;
}
.podio-medalha {
  width: 44px;
  height: 44px;
  margin: 0 auto 6px;
  border-radius: 50%;
  line-height: 44px;
  font-weight: 700;
  color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
}
.podio-nome {
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.podio-cidade {
  font-size: 0.8rem;
  color: #6c757d;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.podio-bloco {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 8px;
  border-radius: 6px 6px 0 0;
  color: #fff;
}
.podio-bloco-num {
  font-size: 1.6rem;
  font-weight: 700;
  line-height: 1.1;
}
.podio-bloco-un {
  font-size: 0.75rem;
  opacity: 0.9;
}
.podio-degrau--1 .podio-medalha,
.podio-degrau--1 .podio-bloco {
  background: #d4a72c;
}
.podio-degrau--1 .podio-bloco {
  height: 110px;
}
.podio-degrau--2 .podio-medalha,
.podio-degrau--2 .podio-bloco {
  background: #9aa3ad;
}
.podio-degrau--2 .podio-bloco {
  height: 85px;
}
.podio-degrau--3 .podio-medalha,
.podio-degrau--3 .podio-bloco {
  background: #b87a45;
}
.podio-degrau--3 .podio-bloco {
  height: 65px;
}
.podio-degrau--eu .podio-nome {
  color: #28a745;
}

/* faixas de premio */
.podio-faixas {
  border: 1px solid #edf0f3;
  border-radius: 6px;
  overflow: hidden;
}
.podio-faixas-titulo {
  padding: 6px 12px;
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  color: #6c757d;
  background: #f8f9fa;
}
.podio-faixa {
  display: flex;
  gap: 12px;
  padding: 7px 12px;
  border-left: 5px solid;
  border-top: 1px solid #edf0f3;
}
.podio-faixa-pos {
  min-width: 90px;
  font-weight: 600;
}
.podio-faixa--0,
.podio-linha--0 td:first-child { border-left-color: #d4a72c; }
.podio-faixa--1,
.podio-linha--1 td:first-child { border-left-color: #6a8cb5; }
.podio-faixa--2,
.podio-linha--2 td:first-child { border-left-color: #5cb85c; }
.podio-faixa--3,
.podio-linha--3 td:first-child { border-left-color: #8a6fb0; }
.podio-faixa--4,
.podio-linha--4 td:first-child { border-left-color: #e0876a; }

/* listas */
.podio-busca {
  display: flex;
  gap: 8px;
  margin-bottom: 8px;
}
.podio-busca input {
  max-width: 320px;
}
.podio-lista {
  position: relative;
  max-height: 520px;
  overflow-y: auto;
  border: 1px solid #e9ecef;
  border-radius: 4px;
}
.podio-lista thead th {
  position: sticky;
  top: 0;
  z-index: 1;
  background: #f8f9fa;
  border-top: 0;
}
.podio-lista td:first-child {
  border-left: 4px solid transparent;
}
.podio-pos {
  width: 60px;
  font-weight: 600;
}
.podio-premio {
  font-size: 0.85rem;
}
.podio-linha--eu td {
  background: #eef8f0;
  font-weight: 600;
}
.podio-rede-resumo {
  margin-bottom: 8px;
  color: #495057;
}

@media (max-width: 576px) {
  .podio-meu {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  .podio-degraus {
    gap: 6px;
  }
  .podio-bloco-num {
    font-size: 1.2rem;
  }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/distribuidor/Home/PodioHome.vue